/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestMaxDynamodbSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_MAX_DYNAMODB_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestMaxDynamodbSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestMaxDynamodbSizeSettingParser.decode(input).map(res => new NewAutoTestMaxDynamodbSizeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestMaxDynamodbSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestMaxDynamodbSizeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestMaxDynamodbSizeSettingParser.schema();
    }
}
